import React, {Component, useEffect, useState} from 'react'
import WebEditorRender from "../../../components/WebEditor";
import AiContentSlot from "../../../components/AiContentSlot";
import ApiService from "../../../services/ApiService";

export default function CustomSection({context,id,section}){

    const [data,setData]=useState(null)
    const {org,config}=context

    const isAi = section?.contentType === "AI"

    const getSection=async ()=>{
        const res=await ApiService.get("/sections/id/"+id)
        if(res){
            setData(res.data)
        }
    }

    useEffect(() => {
        if(isAi) return
        getSection()
    }, [id, isAi]);


    let lang=context.lang?.value || null
    const languages=context.org.languages || []
    if(languages.length>0 && !lang){
        lang=context.org.language
    }

    if(isAi){
        if(!section?.aiContentBlockId) return null
        return (
            <div className={"csection"}>
                <AiContentSlot blockId={section.aiContentBlockId} lang={lang}/>
            </div>
        )
    }

    if(!data){
        return null
    }

    return (
        <div className={"csection"}>
            <WebEditorRender page={data} lang={lang}/>
        </div>
    )
}
